import React from 'react';
import { Alert } from 'react-bootstrap';

export default function AdminEmpty() {
  return (
    <Alert variant="info">
      <Alert.Heading>Administrace a nastavení</Alert.Heading>
      {/*<p>Zde vidíte statistiku operátora a můžete k němu nastavit rozdělování podnětů.</p>*/}
      <hr />
      <p className="mb-0">Zvolte položku v levém menu.</p>
    </Alert>
  );
}
